require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-es-6-set-default-parameters-for-your-functions.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-es-6-set-default-parameters-for-your-functions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-es-6-set-default-parameters-for-your-functions!./.cache/json/javascript-algorithms-and-data-structures-es-6-set-default-parameters-for-your-functions.json
// module id = 2370
// module chunks = 231608221292675